import {SourcingSuspiciousReason} from '@dms/api/core';

/**
 * Every suspiciousReason code Sourcing understands. The data team keeps the list in the
 * shared codelist and can start sending any of them at any time, so the FE keeps the full
 * set here and each code has a label under entity.sourcing.suspiciousReason.*.
 */
export const SOURCING_SUSPICIOUS_REASONS: SourcingSuspiciousReason[] = [
  'suspicious_price_low',
  'suspicious_price_high',
  'suspicious_mileage_low',
  'suspicious_mileage_high',
  'suspicious_dod',
  'manufactured_in_future',
  'leasing',
  'quality_flag_missing_model_family',
  'quality_flag_missing_car_style',
  'quality_flag_car_style_other',
  'quality_flag_missing_drive',
  'quality_flag_missing_power',
  'quality_flag_power_out_of_range',
  'quality_flag_missing_mileage',
  'quality_flag_mileage_out_of_range',
  'quality_flag_missing_price_with_vat',
  'quality_flag_missing_transmission',
  'quality_flag_missing_fuel_type',
  'quality_flag_not_in_selected_fuel_types',
  'quality_flag_missing_year',
  'quality_flag_year_out_of_range',
  'quality_flag_missing_seller_country',
  'quality_flag_not_road_worthy_or_damaged',
  'quality_flag_abnormal_ad_duration',
  'quality_flag_future_car',
  'quality_flag_old_but_not_sold',
  'quality_flag_banished_seller',
  'quality_flag_detected_problems_in_description',
  'quality_flag_same_id_different_car',
  'mileage_outlier_action_remove_immediately',
  'mileage_outlier_action_remove_high_confidence',
  'mileage_outlier_action_remove_medium_confidence',
  'mileage_outlier_action_remove_logz_decides',
  'mileage_outlier_action_keep_review',
  'price_business_rule_invalid_non_positive_price',
  'price_business_rule_invalid_missing_mileage',
  'price_business_rule_invalid_negative_mileage',
  'price_business_rule_invalid_year_out_of_range',
  'price_business_rule_invalid_power_out_of_range',
  'price_business_rule_suspicious_very_low_price',
  'price_business_rule_suspicious_low_price_new_car',
  'price_business_rule_suspicious_high_price_non_luxury',
  'price_business_rule_suspicious_old_car_high_price',
  'data_quality_flag_actual_price_too_low',
  'data_quality_flag_actual_price_too_high',
  'data_quality_flag_actual_to_prediction_extremely_high',
  'data_quality_flag_actual_to_prediction_extremely_low',
  'data_quality_flag_actual_to_cb_prediction_extremely_high',
  'data_quality_flag_actual_to_cb_prediction_extremely_low',
  'prediction_outlier_type_overpriced_outlier',
  'prediction_outlier_type_underpriced_outlier',
  'prediction_outlier_type_overpriced_outlier_cb_only',
  'prediction_outlier_type_underpriced_outlier_cb_only',
  'technical_part_replacement_needed',
  'technical_unspecified_noise',
  'technical_repaired_accident_damage',
  'technical_collision_damage',
  'technical_non_functional',
  'technical_minor_problems',
  'price_conditional_on_financing',
  'price_conditional_on_leasing',
  'price_conditional_on_trade_in_or_scrappage',
  'price_conditional_on_domestic_sale',
  'price_excluding_vat',
  'price_is_for_export_only',
  'price_leasing',
  'price_financing_offer',
  'other_car_is_not_available_now',
  'other_car_is_reserved',
  'other_tuning',
  'other_taxi_driving_school_military_use',
  'other_battery_rental',
  'other_auction',
  'other_car_without_registration',
  'other_origin_outside_europe',
];

/**
 * Reasons that disable Carvago buy — the advertised price is not what the buyer would pay.
 *
 * `leasing` and `price_leasing` are the same signal under two names: the data team is renaming
 * the codes and both spellings can arrive during the transition, so both stay listed. Dropping
 * either one would silently re-enable Carvago buy for leasing-only prices.
 */
export const CARVAGO_BUY_BLOCKED_SUSPICIOUS_REASONS: SourcingSuspiciousReason[] = [
  'price_conditional_on_leasing',
  'price_conditional_on_financing',
  'leasing',
  'price_leasing',
];
